import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { NetworkStatus } from '@apollo/client';

import CardSection from '../containers/CardSection';
import Box from './layout/Box';
import Button from './Button';
import BookListItem from './BookListItem';

const BookList = ({
  title,
  subtitle,
  loading,
  items,
  limit,
  fetchMore,
  networkStatus,
}) => {
  const [currentPage, setCurrentPage] = useState(1);

  const handleLoadMore = () => {
    setCurrentPage((prev) => prev + 1);

    fetchMore({
      variables: {
        pagination: {
          offset: items.length,
          limit,
        },
      },
    });
  };

  const fetchingMore = networkStatus === NetworkStatus.fetchMore;
  const hasNextPage = loading || currentPage * limit === items.length;

  return (
    <CardSection title={title} subtitle={subtitle}>
      <Box className="flex-column">
        {!!items.length &&
          items.map((obj, index) => {
            return (
              <Box
                key={obj.id}
                className="mb-3 pb-3 flex-column"
                style={{
                  borderBottom: '2px solid #e7e7e7',
                }}
              >
                <BookListItem
                  book={obj}
                  showBorder={items.length - 1 !== index}
                />
              </Box>
            );
          })}
      </Box>

      {(fetchingMore || hasNextPage) && (
        <Box
          onClick={handleLoadMore}
          className="align-items-center w-100 justify-content-center my-3"
        >
          <Button isLoading={fetchingMore}>
            <FormattedMessage defaultMessage="Visa fler" />
          </Button>
        </Box>
      )}
    </CardSection>
  );
};

export default BookList;
